<template>
  <div id="app">
    <template v-if="logged()">
      <component-header></component-header>
      <router-view></router-view>
    </template>
    <template v-else>
      <component-login></component-login>
    </template>
    <component-footer></component-footer>
  </div>
</template>

<script>
import componentHeader from './components/layout/Header.vue'
import componentFooter from './components/layout/Footer.vue'

import componentLogin from './components/Login.vue'

export default {
  name: 'app',
  components: {
    componentLogin,
    componentHeader,
    componentFooter,
  },
  methods:{
    logged(){
      return typeof localStorage['user-token'] != 'undefined'
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.vdp-datepicker *{
  border: 0;
}

h1{
  margin: 20px 0;
}
footer{
  margin-top: 100px;
}
</style>
